export const SITE_URL = 'https://e-invitation.online';
export const SITE_NAME = 'E-Invitation by Logica Technology';
export const DEFAULT_TITLE = `${SITE_NAME} | Digital Invitations Philippines`;
export const DEFAULT_DESCRIPTION =
  'Create beautiful digital invitations for weddings, birthdays, christenings, corporate events, and anniversaries. Starting at ₱200. Fast delivery, mobile-friendly. Powered by Logica Technology.';
export const DEFAULT_KEYWORDS =
  'e-invitation, digital invitation, wedding invitation, birthday invitation, christening invitation, corporate invitation, anniversary invitation, Philippines, Logica Technology, e-invite';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/favicon.png`;

export const ORGANIZATION_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: SITE_NAME,
  description:
    'Digital invitation design service for weddings, birthdays, christenings, corporate events, and anniversaries in the Philippines.',
  url: SITE_URL,
  logo: DEFAULT_OG_IMAGE,
  image: DEFAULT_OG_IMAGE,
  email: 'sales@logicatechnology.com',
  sameAs: [
    'https://www.facebook.com/profile.php?id=61585468153192',
    'https://www.tiktok.com/@logicatechnology',
    'https://logicatechnology.com',
  ],
  priceRange: '₱200 - ₱700',
  currenciesAccepted: 'PHP',
  areaServed: 'Philippines',
  serviceType: 'Digital Invitation Design',
};